// extracted by mini-css-extract-plugin
export var SocialFollowButtonsCtaContainer = "SocialFollowButtonsCTA-module--SocialFollowButtonsCtaContainer--bf197";
export var followLinks = "SocialFollowButtonsCTA-module--followLinks--bdc0c";
export var socialCtaHeader = "SocialFollowButtonsCTA-module--socialCtaHeader--a2c1f";
export var socialMediaLink = "SocialFollowButtonsCTA-module--socialMediaLink--608f2";